import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"

const LearnPathDivider = ({ pathItem }) => {
  return (
    <div>
      <Text.H5 inverted>{pathItem.name}</Text.H5>
    </div>
  )
}

LearnPathDivider.displayName = "LearnPathDivider"

LearnPathDivider.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default LearnPathDivider
